import { combineReducers } from 'redux';
import { apiConfiguration } from '../api/api.state';
import appSettings from '../appSettings/app.settings.state';
import codeTables from '../codeTables/codeTables.state';
import glGuidance from '../guidanceCode/guidanceCode.state';
import interactions from '../interactions/interactions.state';
import metadata from '../metadata/metadata.state';
import session from '../security/session.state';
import loading from './loading.state';

export default combineReducers({
  apiConfiguration,
  appSettings,
  codeTables,
  glGuidance,
  interactions,
  loading,
  metadata,
  session
});
